export default __webpack_public_path__ + "static/media/our-mission.1da03ca6.jpg";